export type SourceUrl = string;

function coerceSources(sources: SourceUrl | SourceUrl[]): SourceUrl[] {
  if (!Array.isArray(sources)) {
    sources = [sources];
  }
  return sources;
}

function fetchSource<O>(sourceUrl: string): Promise<O> {
  return fetch(sourceUrl).then((response) => response.json());
}

/**
 * Fetches all files at all source urls and collapses them down into one config, assumed to be of
 * type T. The fetched will be merged from right to left in the same order their urls are passed.
 *
 * Each source url is expected to:
 *   - only require a simple GET
 *   - return a JSON payload
 *   - the payload contains a single JSON object
 *
 * A `baseConfig` can be passed that will be the starting place for merged values.
 *
 * There is no runtime enforcement that the config loaded actually matches type T.
 *
 * @param sources
 * @param baseConfig
 */
export default async function <T>(
  sources: SourceUrl | SourceUrl[],
  baseConfig?: Partial<T>,
): Promise<T> {
  sources = coerceSources(sources);

  const fetchedResponses = await Promise.all(sources.map(fetchSource));
  const combinedConfig = fetchedResponses.reduce((config, configAccumulator) => {
    return Object.assign({}, configAccumulator, config);
  });
  return Object.assign({}, baseConfig as T, combinedConfig);
}
